import { createFileRoute, redirect } from '@tanstack/react-router'

/** Preserve legacy deep links while keeping Brand Settings in the detail tabs. */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands/$brandId/settings')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceId/brands/$brandId',
      params,
      search: { tab: 'settings' },
    })
  },
})
